import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";

import { validaSoloNumero, validaMonto, formatoMonto } from "../../util/varios";
import "react-tabs/style/react-tabs.css";
import axios from "axios";
import CatalogoObraAsignada from "../../catalogos/catalogoObraAsignada";
import CatalogoObraRealizada from "../../catalogos/catalogoObraRealizada";
import CatalogoProveedor from "../../catalogos/catalogoProveedor";
import moment from "moment";
import CatalogoContable from "../../catalogos/catalogoContable";

import { SearchInput, Input } from "../../ui/inputs/Input";
import { DangerButton, SuccessButton, PrimaryButton, InfoButton, WarningButton } from "../../ui/buttons/Button";
import { Button } from "react-bootstrap";

export const ModalVincularObra = (props) => {
  let op = require("../../../src/modulos/datos");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtFecha = useRef();
  const txtId2 = useRef();
  const txtDescrip2 = useRef();
  const txtId3 = useRef();
  const txtDescrip3 = useRef();
  const txtId4 = useRef();
  const txtDescrip4 = useRef();

  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);

  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(1);
  const [habilitado, setHabilitado] = useState(0);
  const [deshabilitadoCta, setDeshabilitadoCta] = useState(true);
  const [operacion, setOperacion] = useState(0);
  const [visible, setVisible] = useState(false);
  const txtId = useRef();
  const txtPorcen = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  let token = localStorage.getItem("jwtToken");

  const validarCampos = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtId4.current.value.trim() === "" || txtDescrip4.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "No se ha Seleccionado Ninguna Cuenta.",
        icono: "informacion",
      });
      sigue = false;
      txtId4.current.focus();
    } 
    if (sigue) {
      vincularobra();
    }
  };

  const cerrarModal = () => {
    //props.setShow(false);
    blanquearCampos();

    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const vincularobra = () => {
    const obra = txtId.current.value;
    const cuenta = txtId4.current.value;

    let endpoint = `${op.conexion}/api/contabilidadfis/vincularobra?idcuenta=${cuenta}&idobra=${obra}`;
    let body;
    setActivate(true);

    axios
      .post(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Vinculación Exitosa.",
            icono: "exito",
          });
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const selecionarRegistro = (id) => {
    let campos = "*";

    let nomtab = "obraasignada";
    let nomid = "idobraasignada";
    let nomid2 = "idefiscal";

    let nomtab2 = "obra";
    let nomid3 = "idobra";

    let endpoint = `${op.conexion}/api/consulta/modeli6?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&id2=${idefiscal}&nomtab2=${nomtab2}&nomid3=${nomid3}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          //console.log(response.data[0]);
          txtFecha.current.value = moment.utc(
            response.data[0].fechaasignacion
          ).format("YYYY-MM-DD");
          txtId.current.value = response.data[0].idobraasignada;
          seleccionarObra(response.data[0].idobra);
          seleccionarProveedor(response.data[0].idproveedor);
          if (response.data[0].idcuentacontable) {
            seleccionarCuenta(response.data[0].idcuentacontable);
          }
          setDeshabilitado(0);
          setDeshabilitadoCta(false);
          txtId4.current.focus();
          setHabilitado(0);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const seleccionarProveedor = (id) => {
    setMostrar2(false);
    let campos = "*";
    let nomtab = "proveedor";
    let nomid = "idproveedor";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          //console.log(response.data);
          txtId3.current.value = response.data.idproveedor;
          txtDescrip3.current.value = response.data.razonsocial;
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const blanquearCampos = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
    txtId.current.value = "";
    txtFecha.current.value = "";
    txtId2.current.value = "";
    txtDescrip2.current.value = "";
    txtId3.current.value = "";
    txtDescrip3.current.value = "";
    txtId4.current.value = "";
    txtDescrip4.current.value = "";
    setActivate(false);
    setOperacion();
    setActivate(false);
    setOperacion();
    setDeshabilitado(1);
    setHabilitado(0);
    setDeshabilitadoCta(true);
    setVisible();
  };

  const salir = () => {
    setDeshabilitado(1);
    props.setShow(false);
    blanquearCampos();
  };

  const agregarObraAsignada = (values) => {
    setMostrar(false);
    //console.log(values);
    selecionarRegistro(values.idobraasignada);
  };

  const seleccionarObra = (id) => {
    setMostrar(false);

    let endpoint = `${op.conexion}/api/contabilidadfis/selectobra?idefiscal=${idefiscal}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            //console.log(response.data);
            txtId2.current.value = response.data.idobra;
            txtDescrip2.current.value = response.data.descripcion;

            setActivate(false);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe una Cuenta Contable con este Codigo.",
              icono: "informacion",
            });
            /*    txtDescripcion.current.value = ''; */
            setActivate(false);
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarObraRealizada = (event) => {
    event.preventDefault();

    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        selecionarRegistro(event.target.value);
      } else {
        txtId.current.value = "";
      }
    }
  };

  const validarObra = (event) => {
    event.preventDefault();

    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarObra(event.target.value);
      } else {
        txtId2.current.value = "";
        txtDescrip2.current.value = "";
      }
    }
  };

  const validarProveedor = (event) => {
    event.preventDefault();

    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarProveedor(event.target.value);
      } else {
        txtId3.current.value = "";
        txtDescrip3.current.value = "";
      }
    }
  };

  const seleccionarCuenta = (id) => {
    setMostrar3(false);

    let endpoint = `${op.conexion}/api/contabilidadfis/selectctaconta?id=${id}&idefiscal=${idefiscal}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            //console.log(response.data);

            txtId4.current.value = response.data.idcuentacontable;
            txtDescrip4.current.value = response.data.descripcion;

            setActivate(false);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe una Cuenta Contable con este Codigo.",
              icono: "informacion",
            });
            /*    txtDescripcion.current.value = ''; */
            setActivate(false);
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarCuenta = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    txtDescrip4.current.value = "";
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarCuenta(event.target.value);
      } else {
        /*  cmbTipo.current.value = ''; */
        /*   txtCuentaContable.current.value = '';
                  txtDescripcion.current.value = ''; */
      }
    }
  };

  const handleVincular = (event) => {
    event.preventDefault();
    setHabilitado(1);
    setDeshabilitado(0);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setDeshabilitado(1);

        setVisible(false);
      }}
    >
      <Modal.Header className="azulGradiant">
        <h3 className="fw-bold m-0">Vinculación de Obras</h3>
        <a
          type="button"
          ref={btnCancela}
          className="text-light fw-bold fs-6"
          onClick={salir}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap justify-content-between">
        <div className="col-4 m-0 p-0">
          <SearchInput
            label="Código:"
            name="idcuentabancaria"
            disabled = {habilitado === 0 ? true : false}
            disabledButton = {habilitado === 0 ? true : false}
            onKeyUp={validarObraRealizada}
            onBlur={validarObraRealizada}
            onClickButton={() => {
              setMostrar(true);
            }}
            ref={txtId}
          />
        </div>
        <div className="col-4 m-0 p-0">
          <Input
            label="Fecha de Asignación:"
            type="date"
            name="idcuentabancaria"
            disabled
            ref={txtFecha}
          />
        </div>
        <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
          <legend className="float-none w-auto">Datos de la Obra</legend>
          <SearchInput
            name="idcuentabancaria"
            disabled
            disabledButton={true}
            onKeyUp={validarObra}
            onBlur={validarObra}
            onClickButton={() => {
              setMostrar1(true);
            }}
            ref={txtId2}
          />
          <Input
            disabled
            id="codigocuenta"
            ref={txtDescrip2}
            name="codigocuenta"
          />
        </fieldset>
        <fieldset className="col-12 m-0 mb-2 p-2 d-flex border-azul rounded">
          <legend className="float-none w-auto">Datos del Contratista</legend>
          <SearchInput
            name="idcuentabancaria"
            disabled
            disabledButton={true}
            onKeyUp={validarProveedor}
            onBlur={validarProveedor}
            onClickButton={() => {
              setMostrar2(true);
            }}
            ref={txtId3}
          />
          <Input
            id="codigocuenta"
            disabled
            name="codigocuenta"
            ref={txtDescrip3}
          />
        </fieldset>
        <div className="col-12 m-0 p-0 d-flex">
          <SearchInput
            label="Código Cuenta:"
            name="idcuentabancaria"
            disabled={deshabilitadoCta}
            disabledButton={deshabilitadoCta}
            onKeyUp={validarCuenta}
            onBlur={validarCuenta}
            onClickButton={() => {
              setMostrar3(true);
            }}
            ref={txtId4}
          />
          <Input
            disabled
            id="codigocuenta"
            name="codigocuenta"
            ref={txtDescrip4}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <PrimaryButton
          disabled={deshabilitado === 1 ? false : true}
          onClick={handleVincular}
          icon="fa-pen-nib"
          //ref={btnAcepta}
        >
            Vincular
        </PrimaryButton>
        <SuccessButton
          disabled={deshabilitadoCta}
          onClick={validarCampos}
          ref={btnAcepta}
        >
            Aceptar
        </SuccessButton>
        <Button
          variant="secondary rounded-pill"
          disabled={deshabilitado === 1 ? true : false}
          onClick={blanquearCampos}
          //ref={btnAcepta}
        >
            Cancelar
            <i className="fw-bold fas ms-2 fas fa-window-close me-1"></i>
        </Button>
        <DangerButton
          onClick={salir}
          disabled={deshabilitado === 1 ? false : true}
          icon="fa-sign-out-alt"
          //ref={btnCancela}
        >
            Salir
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
        }}
      />

      <Dimmer active={activate} inverted></Dimmer>
      <CatalogoObraAsignada
        show={mostrar}
        onHideCancelar={() => {
          setMostrar(false);
        }}
        onHideAcepta={agregarObraAsignada}
      />

      <CatalogoObraRealizada
        show={mostrar1}
        onHideCancelar={() => {
          setMostrar1(false);
        }}
      />

      <CatalogoProveedor
        show={mostrar2}
        onHideCancelaCatProv={() => {
          setMostrar2(false);
        }}
        onHideAceptaCatProv={seleccionarProveedor}
        imp={1}
      />

      <CatalogoContable
        llamado={1}
        show={mostrar3}
        onHideCancela={() => {
          setMostrar3(false);
        }}
        onHideAcepta={seleccionarCuenta}
      />
    </Modal>
  );
};
